// extracted by mini-css-extract-plugin
export default {"wrapper":"MoreButton_wrapper__xNF+G","children":"MoreButton_children__d25R3","more":"MoreButton_more__ACXCh","rotate180":"MoreButton_rotate180__-IJ8b"};